module.exports = __webpack_public_path__ + "img/acms-bo.3e8a9239.svg";